import { Collection } from 'core/model';
import SuppressionModel from './SuppressionModel';

export default class SuppressionCollection extends Collection {
  get url() {
    return '/api/ui/alerting/suppressions';
  }

  get jsonRoot() {
    return 'suppressions';
  }

  get model() {
    return SuppressionModel;
  }

  get defaultSortState() {
    return {
      field: 'creationTime',
      direction: 'desc'
    };
  }
}
